function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import TextBox from './TextBox';
import { MailIcon } from '../../build';
import '../assets/inputFields.css';
const MailBoxField = props => /*#__PURE__*/React.createElement(TextBox, _extends({}, props, {
  key: props.name || +new Date(),
  InputProps: {
    startAdornment: /*#__PURE__*/React.createElement(MailIcon, null)
  }
}));
const MailBox = withStyles({
  root: {
    '& .MuiInputBase-root': {
      color: 'white',
      fontWeight: 500
    },
    '& svg': {
      margin: '10px'
    },
    '& .MuiInput-underline:before': {
      borderBottomColor: 'white'
    },
    '& .MuiInput-colorSecondary.MuiInput-underline:after': {
      borderColor: 'white',
      borderBottomColor: 'white !important'
    }
  }
})(MailBoxField);
MailBoxField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number
};
export default MailBox;